import './styles/app.css';
import Alpine from 'alpinejs';
import { authPageData } from './pages/authPageData';
import { shouldAutoRedirect } from './pages/afterSignIn';
import { AuthService } from './services/AuthService';
import { DeviceDetector } from './utils/DeviceDetector';
import { redirectAfterAuth } from './utils/redirectAfterAuth';
import { applyDocumentLanguage, translate } from './utils/i18n';
import { BRAND } from '../shared/utils/brand.js';

/**
 * Login Page Entry Point
 *
 * Standalone login page that redirects to map after successful authentication.
 * Handles returnTo parameter to preserve intended destination.
 */

// The page renders entirely from the i18n dictionary, so `<html lang>` has to
// follow the resolved language rather than the `en` baked into the markup.
const uiLang = applyDocumentLanguage();
document.title = `${translate('pageTitleLogin', uiLang)} - ${BRAND.name}`;

// Initialize device detection early
DeviceDetector.initialize();

// Make AuthService globally available for Alpine.js components
const authService = new AuthService();
(window as any).__authService__ = authService;

// Register Alpine.data component
Alpine.data('authPageData', authPageData);

// Start Alpine.js
Alpine.start();

// Two pages must NOT auto-bounce an already-authenticated browser: desktop
// mode (?client= from KingCAD, kingcad#426 — the CAD user came here on
// purpose) and the #675 name step (?welcome=1 — signed in by design). Both
// paths below must be gated: fetchCurrentUser() fires notifyStateChange on
// success, so the subscriber would redirect at load even without the probe.
// The interactive-login submit path (authPageData) keeps its own redirect.
if (shouldAutoRedirect()) {
  // Check if already authenticated on page load
  void authService.getCurrentUser().then((user) => {
    if (user) {
      // User is already authenticated, redirect to dashboard
      redirectAfterAuth();
    }
  });

  // Listen for authentication success
  authService.onAuthStateChanged((user) => {
    if (user) {
      // User just logged in, redirect to dashboard
      redirectAfterAuth();
    }
  });
}
